import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostStockReceiveBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Submits a stock receive against a batch, then refreshes cached product stock. */
export function usePostStockReceive() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostStockReceiveBody) => {
      const response = await api.post('/stock/receive', { body })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] })
      queryClient.invalidateQueries({ queryKey: ['product'] })
    },
  })
}
